import React, { useState } from 'react';
import { FiSettings } from 'react-icons/fi';

const Magnipavti = () => {
  // Word data mapping for auto-population
  const wordData = {
    '1': { receiptNumber: '101', ownerName: 'shubham', propertyNo: '11' },
    '2': { receiptNumber: '12', ownerName: 'sangram', propertyNo: '102' },
    '3': { receiptNumber: '13', ownerName: 'sagar', propertyNo: '103' }
  };

  const [filters, setFilters] = useState({
    orderBy: 'मालमत्ता न',
    date: '',
    startPage: '0',
    pageLimit: '300',
    wardName: '',
    receiptNumber: '',
    ownerName: '',
    propertyNo: '',
    remarks: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
    // Clear error for this field when user starts typing
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  // Handle word name change to auto-populate other fields
  const handleWardNameChange = (value) => {
    const wordInfo = wordData[value] || { receiptNumber: '', ownerName: '', propertyNo: '' };
    setFilters({
      ...filters,
      wardName: value,
      receiptNumber: wordInfo.receiptNumber,
      ownerName: wordInfo.ownerName,
      propertyNo: wordInfo.propertyNo
    });
    // Clear error for wardName when user selects
    if (errors.wardName) {
      setErrors({ ...errors, wardName: '' });
    }
  };

  const validateFilters = () => {
    const newErrors = {};
    
    if (!filters.date) {
      newErrors.date = 'दिनांक निवडा';
    }
    
    if (!filters.wardName) {
      newErrors.wardName = 'वॉर्डचे नाव निवडा';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNewRecord = () => {
    setFilters({
      orderBy: 'मालमत्ता न',
      date: '',
      startPage: '0',
      pageLimit: '300',
      wardName: '',
      receiptNumber: '',
      ownerName: '',
      propertyNo: '',
      remarks: ''
    });
    setErrors({});
    setMessage({ type: 'success', text: 'नवीन फॉर्म तयार केला' });
    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const handleWhatsAppShare = () => {
    if (!validateFilters()) {
      setMessage({ type: 'error', text: 'कृपया सर्व आवश्यक फील्ड भरा' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      setMessage({ type: 'success', text: 'WhatsApp वर रिपोर्ट पाठवला गेला' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      
      // Open WhatsApp (example)
      const message = `मागणी पावती रिपोर्ट\nदिनांक: ${filters.date}\nवॉर्ड: ${filters.wardName}`;
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    }, 1000);
  };

  const handlePrintReceipt = () => {
    if (!validateFilters()) {
      setMessage({ type: 'error', text: 'कृपया सर्व आवश्यक फील्ड भरा' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    setLoading(true);
    // Simulate print preparation
    setTimeout(() => {
      setLoading(false);
      setMessage({ type: 'success', text: 'पावती प्रिंट करण्यासाठी तयार' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      window.print();
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white p-4 rounded-t-lg shadow-md">
        <h1 className="text-xl font-bold">मागणी पावती</h1>
      </div>

      {/* Main Content */}
      <div className="bg-white shadow-lg rounded-b-lg p-6">
        {/* Success/Error Message */}
        {message.text && (
          <div className={`mb-4 p-3 rounded ${message.type === 'success' ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-red-100 text-red-800 border border-red-300'}`}>
            {message.text}
          </div>
        )}
        {/* Filter Row 1 */}
        <div className="mb-4">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mb-2">
            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                Order By :
              </label>
              <select
                value={filters.orderBy}
                onChange={(e) => handleFilterChange('orderBy', e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="मालमत्ता न">मालमत्ता न</option>
                <option value="पावती नं">पावती नं</option>
                <option value="नाव">नाव</option>
              </select>
            </div>

            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                दिनांक :
              </label>
              <input
                type="date"
                value={filters.date}
                onChange={(e) => handleFilterChange('date', e.target.value)}
                className={`flex-1 px-3 py-2 border ${errors.date ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
              {errors.date && <span className="text-red-500 text-xs">{errors.date}</span>}
            </div>

            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                पासून :
              </label>
              <input
                type="text"
                value={filters.startPage}
                onChange={(e) => handleFilterChange('startPage', e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="0"
              />
            </div>

            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                पर्यंत :
              </label>
              <input
                type="text"
                value={filters.pageLimit}
                onChange={(e) => handleFilterChange('pageLimit', e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="300"
              />
            </div>
          </div>

          <div className="mt-2">
            <p className="text-sm text-red-600 font-medium">
              थकबाकी आणि घरपट्टी माहिती प्रदर्शित (रुपये 1,400:401-4:00)
            </p>
          </div>
        </div>

        {/* Filter Row 2 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              वॉर्डचे नाव :
            </label>
            <div className="flex items-center gap-2">
              <select
                value={filters.wardName}
                onChange={(e) => handleWardNameChange(e.target.value)}
                className={`flex-1 px-3 py-2 border ${errors.wardName ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
              >
                <option value="">निवडा</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
              {errors.wardName && <span className="text-red-500 text-xs block mt-1">{errors.wardName}</span>}
              <button className="text-red-500 hover:text-red-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              पावती नंबर :
            </label>
            <input
              type="text"
              value={filters.receiptNumber}
              onChange={(e) => handleFilterChange('receiptNumber', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="निवडा"
              readOnly={filters.wardName !== ''}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              मालकाचे नाव :
            </label>
            <input
              type="text"
              value={filters.ownerName}
              onChange={(e) => handleFilterChange('ownerName', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="निवडा"
              readOnly={filters.wardName !== ''}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              मालमत्ता क्र. :
            </label>
            <input
              type="text"
              value={filters.propertyNo}
              onChange={(e) => handleFilterChange('propertyNo', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="निवडा"
              readOnly={filters.wardName !== ''}
            />
          </div>
        </div>

       

        {/* Action Buttons */}
        <div className="flex justify-center gap-3">
          <button 
            onClick={handleNewRecord}
            disabled={loading}
            className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            नवीन
          </button>
          
          <button 
            onClick={handleWhatsAppShare}
            disabled={loading}
            className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded font-medium transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            {loading ? 'पाठवत आहे...' : 'Send Report to WhatsApp'}
          </button>
          <button 
            onClick={handlePrintReceipt}
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'तयारी करत आहे...' : 'प्रिंट पावतीची पुस्तिका'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Magnipavti;
